/**
 * Internal method for plucking a query param from the location.
 * @param {Object} location Location object with href property.
 * @param {Object} history History object with replaceState method.
 * @param {string} param The query string parameter to search for and remove.
 * @return {string} The value of the query string parameter if present.
 */
export function _pluckQueryParam(location, history, param) {
  // const parsed = url.parse(location.href, true);
  // const query = parsed.query;
  // let value;
  // if (param in query) {
  //   value = query[param];
  //   delete query[param];
  //   delete parsed.search;
  //   const newParsed = url.parse(url.format(parsed));
  //   let newUrl = newParsed.path;
  //   if (newParsed.hash) {
  //     newUrl += newParsed.hash;
  //   }
  //   history.replaceState(null, '', newUrl);
  // }
  // return value;
  const url = new URL(location.href);
  const searchParams = url.searchParams;
  let value;
  if (searchParams.has(param)) {
    value = searchParams.get(param);
    searchParams.delete(param);
    history.replaceState(null, '', url.toString());
  }
  return value;
}

/**
 * Pluck a query param from the location.  If the query param is present,
 * it will be removed from the query string.
 * @return {string} The value of the query string parameter if present.
 */
export default function (param) {
  return _pluckQueryParam(window.location, window.history, param);
}
